import React, {ReactElement} from 'react';
import { RAISE_GRIEVANCE_ROUTE } from '../../../config/route/NestedRoutesConfig';
import NestedRoute from '../../../shared/components/tabs/NestedRoute';
import { getMappedRoute } from '../../../utils/routeUtility';

const RaiseGrievance = ({ match, location }: any): ReactElement => {
  const nextDefaultPage = getMappedRoute(location?.pathname, RAISE_GRIEVANCE_ROUTE) || RAISE_GRIEVANCE_ROUTE[0].routeName;

  return (
    <NestedRoute
      match={match}
      defaultPage={nextDefaultPage}
      nestedNav={RAISE_GRIEVANCE_ROUTE}
      // commonComponent={CommonTab}
    />
  );
};
export default RaiseGrievance;
